import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { issueLinkInformationResource } from '@atlassian/jira-router-resources-advanced-roadmaps-settings/src/services/issue-link/index.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { arjSettingsDependenciesLegacyRedirectRoute } from '@atlassian/jira-router-routes-advanced-roadmaps-settings-routes/src/arjSettingsDependenciesLegacyRedirectRoute.tsx';
import { LazyArjSettingsDependencies } from './ui/index.tsx';
import { redirectTo } from './ui/redirect.tsx';

export const arjSettingsDependenciesLegacyRedirectRouteEntry = createEntry(
	arjSettingsDependenciesLegacyRedirectRoute,
	() => ({
		group: 'software',
		component: redirectTo('/jira/plans/settings/dependencies'),
		isRedirect: true,
		layout: globalSettingsLayout,
		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_PRODUCTS_SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsProducts,
		},
		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			issueLinkInformationResource,
		],
		forPaint: [LazyAtlassianNavigation, LazyArjSettingsDependencies],
	}),
);
